module.exports = __webpack_public_path__ + "src/assets/images/note.84186ae28db10d2458a57765776a1d29.svg";